const useSearchParam = () => {
	const match = /search=([^&]+)/.exec(window.location.search);
	return match ? decodeURIComponent(match[1]) : undefined;
};

export default useSearchParam;
